module.exports = __webpack_public_path__ + "img/xianxia.bf413f1e.jpg";